import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { User } from '../models/user';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { LocalStorageKeyOptions, LocalStorageService } from './local-storage.service';
import { ConfigService } from 'ngx-envconfig';
import { catchError, tap, map } from 'rxjs/operators';

import { Panel, Roles } from '../enums';
import { Router } from '@angular/router';
import { Role2Privileges } from '../models/role2-privileges';
import { ResponseDTO } from '../models/response-dto';
import { AppSettings } from '../shared/App-Settings';

@Injectable({
  providedIn: 'root'
})
export class AuthenticationService {

  private accesstoken: string;
  private currentUserSubject: BehaviorSubject<User>;
  public currentUser: Observable<User>;
  public baseurl: string;
  userPrivileges: Role2Privileges[] = [];

  constructor(private httpClient: HttpClient, private router: Router,
    private local: LocalStorageService) {
    this.currentUserSubject = new BehaviorSubject<User>(JSON.parse(localStorage.getItem('currentUser')));
    // this.currentUserSubject.value.token = localStorage.getItem('token');
    this.currentUser = this.currentUserSubject.asObservable();
  }

  public get currentUserValue(): User {
    return this.currentUserSubject.value;
  }

  pushNextUser(user) {
    return this.currentUserSubject.next(user);
  }

  login(email: string, encryptedPassword: string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
      })
    };

    let url = AppSettings.API_BASE_URL + "account/UserAuthentication";

    return this.httpClient.post<any>(url, { email, encryptedPassword }, httpOptions)
      .pipe(map(res => {
        if (res && res.result.token) {
          // store user details in local storage to keep user logged in
          localStorage.setItem('currentUser', JSON.stringify(res.result.user));
          this.local.setItem(LocalStorageKeyOptions.Token, res.result.token);
          this.local.setItem(LocalStorageKeyOptions.RefreshToken, res.result.refreshToken);
          this.local.setItem(LocalStorageKeyOptions.Expiration, res.result.expiration);
          let user = res.result.user;
          user.token = res.result.token;

          this.currentUserSubject.next(user);
        //  this.startRefreshTokenTimer();
        }

        return res;
      }));
  }
  logout() {    
    let accessToken = this.getAccessToken();
    // remove user data from local storage for log out
    ///this.stopRefreshTokenTimer();
    localStorage.removeItem('currentUser');
    localStorage.removeItem(LocalStorageKeyOptions.Token);
    localStorage.removeItem(LocalStorageKeyOptions.Expiration);
    localStorage.removeItem(LocalStorageKeyOptions.RefreshToken);
    localStorage.removeItem('isAZ');
    localStorage.removeItem('countryId');
    localStorage.removeItem('headerImage');
    localStorage.removeItem('title');
    localStorage.removeItem('privileges');
    localStorage.removeItem('isWarehouse');

    this.currentUserSubject.next(null);
    

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };
    let url = AppSettings.API_BASE_URL + "Logout";
    return this.httpClient.post<any>(url, {}, httpOptions);
  }

  getAccessToken(): string {
    return this.local.getItem(LocalStorageKeyOptions.Token);
  }

  getPortalToken(portal) {
    let accessToken = this.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`
      })
    };

    let url = `${AppSettings.API_BASE_URL}GetPortalToken`;

    return this.httpClient.post<any>(url, portal, httpOptions)
      .pipe(map(res => {
        if (res && res.result.token) {
          // store user details in local storage to keep user logged in
          localStorage.setItem('currentUser', JSON.stringify(res.result.user));
          this.local.setItem(LocalStorageKeyOptions.Token, res.result.token);
          this.local.setItem(LocalStorageKeyOptions.RefreshToken, res.result.refreshToken);
          this.local.setItem(LocalStorageKeyOptions.Expiration, res.result.expiration);
          let user = res.result.user;
          user.token = res.result.token;
          this.currentUserSubject.next(user);
        }

        return res;
      }));
  }

  isLoggedIn(): boolean {

    //return this._user && this._user.token && !this._user.expired;
    // check if current user us logged in or not.
    return this.currentUserValue != undefined;

  }
  isAdmin() {
    return this.isLoggedIn() && this.currentUserValue?.isAdmin;
    //&& this.currentUserValue.panel == Panel.Admin;
  }

  unAuthorised() {
    this.router.navigate(['/unauthorised']);
  }

  hasPrivilege(privilegeName: string) {
    if (this.isAdmin() && (this.currentUserValue?.role == "Super Admin" || this.currentUserValue?.role == "Franchisor Owner")) {
      return true;
    }
    else {
      //temporary fix for view related privileges.
      if(privilegeName.indexOf('-view') > -1)
        return true; 
      this.userPrivileges = this.local.getItem(LocalStorageKeyOptions.Privileges);
      if (this.userPrivileges)
        return this.userPrivileges.some(function (el) { return el.privilege.nameNormalised === privilegeName });
      else
        return false;
    }
  }

  setVisibility(panel: Panel) {
    
      return this.currentUserValue?.panel === panel;
   
    /*
    if (this.isAdmin()) {
      return true;
    }
    else {
      return this.currentUserValue.panel === panel;
    }*/
  }

  checkCurrentPanel(userPanel: Panel) {
    return this.currentUserValue?.userPanel == userPanel;
  }

  // helper methods

  private refreshTokenTimeout;

  private startRefreshTokenTimer() {
    // parse json object from base64 encoded jwt token
    const jwtToken = this.currentUserValue?.token.split('.')[1];


    // set a timeout to refresh the token a minute before it expires
    const expires = new Date(jwtToken.exp * 1000);
    const timeout = expires.getTime() - Date.now() - (60 * 1000);
    this.refreshTokenTimeout = setTimeout(() => this.RefreshToken().subscribe(), timeout);
  }

  private stopRefreshTokenTimer() {
    clearTimeout(this.refreshTokenTimeout);
  }



  RefreshToken() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
      })
    };

    const data = JSON.stringify({ token: this.local.getItem(LocalStorageKeyOptions.Token), refreshToken: this.local.getItem(LocalStorageKeyOptions.RefreshToken) });

    let url = `${AppSettings.API_BASE_URL}account/RefreshToken`;

    return this.httpClient.post<any>(url, data, httpOptions)
      .pipe(map(res => {

        if (res && res.result.token) {
          this.local.setItem(LocalStorageKeyOptions.Token, res.result.token);
          this.local.setItem(LocalStorageKeyOptions.Expiration, res.result.expiration);
          this.local.setItem(LocalStorageKeyOptions.RefreshToken, res.result.refreshToken);
          let user = res.result.user;
          user.token = res.result.token;
          this.currentUserSubject.next(user);
          this.startRefreshTokenTimer();
        }
        return res;

      }));

  }

  forgotPassword(emailAddress: string): Observable<ResponseDTO> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'from-customer': 'true'
      })
    };
    let url = AppSettings.API_BASE_URL + "account/PasswordRecovery";

    return this.httpClient.post<any>(url, { email: emailAddress, isCustomer: false }, httpOptions).pipe(
      tap(_ =>
        console.log(`forgot password`)
      ),
      // catchError(this.handleError<ResponseDTO>(`getSiteSettingsById id=${id}`))
    );
  }

  validate(query): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0'
      })
    };
    let url = AppSettings.API_BASE_URL + "account/validate?query=" + query;
    return this.httpClient.get<any>(url, httpOptions);
  }

  resetPassword(email, newEncryptedPassword): Observable<any> {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
      })
    };

    let url = AppSettings.API_BASE_URL + "account/ResetPassword";
    return this.httpClient.post<any>(url, { Email: email, NewPasswordEncrypted: newEncryptedPassword }, httpOptions);
  }


  loginAsCustomer(customerId) {
    let accessToken = this.getAccessToken();
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'api-version': '1.0',
        'Authorization': `Bearer ${accessToken}`

      })
    };

    let url = AppSettings.API_BASE_URL + "account/UserAuthentication/GenerateCustomerToken";

    return this.httpClient.post<any>(url, { customerId: Number(customerId) }, httpOptions);
  }
}
